export default () => {
  jQuery('.wp-block-matchwerk-collapsible.collapsible').each(function() {
    jQuery(this).find('.collapsible__head')[0].onclick = null
    jQuery(this).find('.collapsible__footer')[0].onclick = null

    const $el = jQuery(this).find('.collapsible__head, .collapsible__footer')
    $el.click(function() {
      $el.toggleClass('active')
    })
  })
}
